import React from 'react';
import {Link} from "react-router-dom";
import Nav from './Nav';
import { useFavorites } from '../../hooks/use-favorites';
import { useComparison } from '../../hooks/use-comparison';

const HeaderTwo = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';
    const { favoritesCount } = useFavorites();
    const { count: compareCount } = useComparison();

    return (
        <>
            <header className="main-header main-header-one main-header-one--two clearfix">
                <div className="main-header-one__wrapper">
                    <div className="main-header-one__bottom">
                        <nav className="main-menu main-menu--1">
                            <div className="main-menu__wrapper">
                                <div className="container">
                                    <div className="main-menu__wrapper-inner">
                                        <div className="main-header-one__bottom-left">
                                            <div className="logo">
                                                <Link to={process.env.PUBLIC_URL + `/`}>
                                                    <span className="freshswfl-logo__lockup">
                                                        <img
                                                            className="freshswfl-logo__icon"
                                                            src={publicUrl + "favicon.svg"}
                                                            alt="FreshSWFL.com"
                                                        />
                                                        <span className="freshswfl-logo__text">
                                                            FRESHSWFL.COM
                                                            <span className="freshswfl-logo__tagline">Southwest Florida local food guide</span>
                                                        </span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="main-header-one__bottom-right">
                                            <Nav />

                                            <div className="freshswfl-header-actions">
                                                <Link
                                                    to="/search"
                                                    className="freshswfl-icon-btn"
                                                    title="Search"
                                                    aria-label="Search"
                                                >
                                                    <span className="material-symbols-outlined" aria-hidden="true">search</span>
                                                </Link>

                                                <Link
                                                    to="/favorites"
                                                    className="freshswfl-icon-btn"
                                                    title="Favorites"
                                                    aria-label="Favorites"
                                                >
                                                    <span className="material-symbols-outlined" aria-hidden="true">favorite</span>
                                                    {favoritesCount > 0 && (
                                                        <span className="freshswfl-icon-badge freshswfl-icon-badge--accent">
                                                            {favoritesCount > 99 ? '99+' : favoritesCount}
                                                        </span>
                                                    )}
                                                </Link>

                                                <Link
                                                    to="/compare"
                                                    className="freshswfl-icon-btn"
                                                    title="Compare Vendors"
                                                    aria-label="Compare Vendors"
                                                >
                                                    <span className="material-symbols-outlined" aria-hidden="true">compare_arrows</span>
                                                    {compareCount > 0 && (
                                                        <span className="freshswfl-icon-badge freshswfl-icon-badge--base">
                                                            {compareCount}
                                                        </span>
                                                    )}
                                                </Link>
                                            </div>

                                            <div className="main-header-one__bottom-right-btn ml-4">
                                                <Link to={process.env.PUBLIC_URL + `/browse`} className="thm-btn">
                                                    Browse Directory
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    );
};

export default HeaderTwo;
